import { render, staticRenderFns } from "./OrderedTable.vue?vue&type=template&id=4342da64"
import script from "./OrderedTable.vue?vue&type=script&lang=js"
export * from "./OrderedTable.vue?vue&type=script&lang=js"
import style0 from "./OrderedTable.vue?vue&type=style&index=0&id=4342da64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports